import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: { token: localStorage.getItem("loggedInUser") },
  reducers: {
    setCredentials: (state, action) => {
      const { accessToken, userLogo, displayUsername, userEmailid, userPhone } = action.payload;
      console.log(accessToken);
      state.token = accessToken;
      state.logo = userLogo;
      state.name = displayUsername;
      state.email = userEmailid;
      state.Phone = userPhone;


      // localStorage.setItem("loggedInUser", accessToken);
    },
    logOut: (state, action) => {
      state.token = null;
      state.logo = null;
      // localStorage.removeItem("loggedInUser");
    },
  },
});

export const { setCredentials, logOut } = authSlice.actions;
export default authSlice.reducer;
export const selectedUserLogo = (state) => state.auth.logo;
export const selectedDisplayUsername = (state) => state.auth.name;
export const selectedUserEmailId = (state) => state.auth.email;
export const selectedUserPhone = (state) => state.auth.Phone;
export const selectCurrentToken = (state) => state.auth.token;

